import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Pass-through layout; the list lives in `sites/index.tsx`. */
export const Route = createFileRoute('/app/$orgId/sites')({
  component: Outlet,
});
